//eslint-disable-next-line
import { DefaultTheme } from 'styled-components'
import defaultBgImage from 'assets/backgrounds/main-bg.jpg'
import defaultBgImageSecondary from 'assets/backgrounds/main_bg_secondary.jpeg'
import { atomDark, prism } from 'react-syntax-highlighter/dist/esm/styles/prism'

const darkTheme: DefaultTheme = {
    body: {
        backgroundImage: defaultBgImage,
        backgroundColorPrimary: '#000',
        boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.3)',
        backgroundColorSecondary: 'rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(100px)',
        textColorPrimary: 'rgba(255, 255, 255)',
        textColorSecondary: 'rgba(255,255,255, 0.8)',
        textColorTertiary: '#000',
        border: 'none',
        backgroundImageSecondary: defaultBgImageSecondary,
        testVariableColor: 'var(--color-brand-blue)',
        iconColor: 'rgb(255, 255, 255)',
        mainNavColorActive: 'var(--content-content-primary, #FFF)',
        mainNavColor: 'var(--content-content-tertiary, rgba(255, 255, 255, 0.6))',
        breadCrumbsColor: 'rgba(255, 255, 255, 0.80)',
        breadCrumbsBg: 'rgba(255, 255, 255, 0.1)',
        commandBorderColor: ' 1px solid var(--basic-foreground-white-2, rgba(255, 255, 255, 0.2))',
        placeHolderColor: 'rgba(255, 255, 255, 0.6)',
        cardBgColor: 'rgba(0, 0, 0, 0.2)',
        secondaryBorder: '1px solid #5a5555',
        secondaryBorderBackground: '#5a5555',
        humanMessageBgColor: '#3a3a3a',
        replyBoxBgColor: 'rgba(0, 0, 0, 0.4)',
        secondaryIconColor: 'rgb(255, 255, 255)',
        tertiaryIconColor: 'rgb(130,130,130)',
        avatarDropDownColor: 'rgb(32 33 36)',
        detailCardBackgroundColor: 'rgba(255, 255, 255, 0.1)',
        toolkitCardBgColorPrimary: 'linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.4) 100%)',
        toolkitCardBgColorSecondary: 'rgba(0, 0, 0, 0.8)',
        toolkitCardBgColorTertiary: '#000',
        teamChatCardSelectedColor: 'rgba(250, 250, 250, 0.1)',
        componentsWrapperBg: 'rgb(32, 33, 35)',
        componentsSecondaryWrapperBg: 'rgba(255, 255, 255, 0.1)',
        textareaBorder: 'transparent',
        textAreaBgColor: 'rgba(255, 255, 255, 0.2)',
        dropdownBgColor: 'transparent',
        dataLoaderCardBorder: '#48ecf0',
        tableBackgroundColor: '#1a1a1a',
        sliderBackgroundColor: '#FFF',
        dropdownSecondaryBgColor: 'rgba(0, 0, 0, 0.7)',
        commandMenuBackgroundColor: ' var(--basic-foreground-black-1, rgba(0, 0, 0, 0.1))',
        warningToastTextColor: 'rgb(110,110,110)',
        sessionDropdownBorder: 'none',
        tagColor: 'gradient_blue',
        imageBrightness: 'brightness(0) invert(1)',
        dialogBorder: 'rgb(45 45 45)',
        linkTextColor: '#00AFF4',
        textDisabled: '#FFFFFF66',
        markdownColor: atomDark,
    },
    contentLoader: {
        bgColor: '#4a4a4a',
        fgColor: '#6a6a6a',
        mainBgColor: '#1e1e1e',
        borderColor: '#444',
    },
    typography: {
        contentPrimary: '#FFF',
        contentSecondary: 'rgba(255, 255, 255, 0.8)',
        contentTertiary: 'rgba(255, 255, 255, 0.6)',
        contentQuaternary: 'rgba(255, 255, 255, 0.4)',
    },
    heading: {
        contentPrimary: '#FFF',
        contentSecondary: 'rgba(255, 255, 255, 0.9)',
        contentTertiary: 'rgba(255, 255, 255, 0.4)',
    },
    button: {
        primary: {
            color: '#000000CC',
            bgColor: '#F5F5F7',
            hoverBgColor: 'rgba(245, 245, 247, 0.8)',
            pressedBgColor: 'rgba(245, 245, 247, 0.8)',
            pressedBorderColor: 'rgba(250, 250, 250, 0.4)',
        },
        secondary: {
            color: 'rgba(0, 0, 0, 0.7)',
            bgColor: 'rgba(255, 255, 255, 0.6)',
            hoverBgColor: 'rgba(255, 255, 255, 0.3)',
            pressedBgColor: 'rgba(255, 255, 255, 0.6)',
            pressedBorderColor: 'rgba(255, 255, 255, 0.2)',
        },
        tertiary: {
            color: '#fff',
            bgColor: 'transparent',
            hoverBgColor: 'rgba(255, 255, 255, 0.2)',
            pressedBgColor: 'rgba(255, 255, 255, 0.2)',
            pressedBorderColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    textFiled: {
        primary: {
            bgColor: 'transparent',
            color: '#fff',
            borderColor: '#5a5555',
            activeBoxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
            activeBorderColor: 'rgba(255, 255, 255, 0.2)',
            activeBgColor: 'rgba(255, 255, 255, 0.05)',
            errorBorderColor: '#e44258',
            errorColor: '#e44258',
        },
    },
    tabs: {
        color: 'rgba(255, 255, 255, 0.6)',
        hoverBgColor: 'rgba(0, 0, 0, 0.2)',
        activeColor: '#fff',
        activeBgColor: 'rgba(0, 0, 0, 0.5)',
        borderColor: 'Transparent',
    },

    // new colors
    basicForeground: {
        white: '#FFF',
        white8: '#FFFFFFCC',
        white6: '#FFFFFF99',
        white4: '#FFFFFF66',
        white3: '#FFFFFF4D',
        white2: '#FFFFFF33',
        white1: '#FFFFFF1A',
        black1: '#0000001A',
        black2: '#00000033',
        black3: '#0000004D',
        black5: '#00000080',
        black7: '#000000B2',
        black8: '#000000CC',
        black: '#000000',
    },
    foundation: {
        primaryA: '#FFFFFF',
        primaryB: '#000000',
        accentBlue: '#18A0FB',
        accentYellow: '#FFC700',
        accentGreen: '#1BC47D',
        negative: '#EF5533',
        warning: '#EEA03C',
        positive: '#1BC47D',
        purple: '#BD47FF',
        beige: '#E3D6BD',
    },
    core: {
        background: {
            backgroundPrimary: '#FFFFFF',
            backgroundSecondary: '#000000',
            backgroundTertiary: 'rgb(32 33 36)',
            backgroundElementsA: '#0000001A',
            backgroundElementsB: '#FFFFFF33',
            backgroundMain: '#18A0FB',
        },
        content: {
            contentPrimary: '#000000',
            contentSecondary: '#000000CC',
            contentTertiary: '#0000004D',
            contentQuaternary: '#FFFFFF',
        },
        border: {
            borderPrimary: '#00000033',
            borderSecondary: '#FFFFFF33',
            borderTertiary: '#FFFFFF4D',
            borderQuaternary: '#FFFFFF1C',
            borderSelectedA: '#18A0FB',
            borderSelectedB: '#FFFFFF',
            borderSelectedC: '#18A0FB',
        },
    },
    coreExtensions: {
        background: {
            backgroundDisabled: '#0000001A',
            backgroundOverlayDark: '#00000033',
            backgroundOverlayLight: '#FFFFFF33',
            backgroundAccent: '#18A0FB',
            backgroundNegative: '#EF5533',
            backgroundWarning: '#EEA03C',
            backgroundPositive: '#17C568',
        },
        content: {
            contentDisabled: '#00000066',
            contentExtra: '#000000CC',
            contentExtra6: '#00000099',
            contentAccent: '#18A0FB',
            contentNegative: '#F01D1D',
            contentWarning: '#EEA03C',
            contentPositive: '#17C568',
        },
        border: {
            borderDisabled: '#00000066',
            borderHover: '#0000000D',
            borderPressed: '#000000',
            borderNegative: '#EF5533',
            borderWarning: '#EEA03C',
            borderPositive: '#17C568',
        },
        multiplayer: {
            mpGray: '#D9D9D9',
            mpGreen: '#17C568',
            mpPink: '#FA2D5A',
            mpLightBlue: '#68B3FD',
            mpRed: '#EF5533',
            mpBlue: '#1B9DFE',
            mpPurple: '#BD47FF',
        },
        tags: {
            tagsBlack: '#000000',
            tagsWhite: '#FFFFFF',
            tagsGrey: '#D9D9D9E5',
            tagsGreen: '#17C568E5',
            tagsPink: '#FA2D5AE5',
            tagsLightBlue: '#68B3FDE5',
            tagsRed: '#EF5533E5',
            tagsBlue: '#1B9DFEE5',
            tagsPurple: '#BD47FFE5',
            tagsYellow: '#FFC700E5',
            tagsOrange: '#EEA03CE5',
        },
    },
}

const lightTheme: DefaultTheme = {
    body: {
        backgroundImage: defaultBgImage,
        backgroundColorPrimary: 'rgb(253,252,250)',
        backgroundColorSecondary: 'rgba(0, 0, 0, 0.1)',
        boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(50px);',
        textColorPrimary: 'rgb(0, 0, 0)',
        textColorSecondary: 'rgb(110,110,110)',
        textColorTertiary: 'rgb(255, 255, 255)',
        border: '1px solid #acacad',
        backgroundImageSecondary: defaultBgImageSecondary,
        testVariableColor: 'var(--color-highlight_blue)',
        iconColor: '#000',
        mainNavColorActive: 'rgb(80,80,80)',
        mainNavColor: 'rgb(193,193,193)',
        breadCrumbsColor: 'rgb(91,91,91)',
        breadCrumbsBg: 'rgb(253,252,250)',
        commandBorderColor: '1px solid rgb(126,126,126)',
        placeHolderColor: 'rgb(187,187,187)',
        cardBgColor: 'rgb(255,255,255)',
        secondaryBorder: '1px solid lightGray',
        secondaryBorderBackground: 'lightGray',
        tertiaryIconColor: 'rgb(130,130,130)',
        humanMessageBgColor: 'rgb(240,240,240)',
        replyBoxBgColor: 'rgb(194,194,194)',
        secondaryIconColor: 'rgb(255, 255, 255)',
        avatarDropDownColor: 'rgb(255, 255, 255)',
        detailCardBackgroundColor: 'rgba(0,0,0,0.1)',
        toolkitCardBgColorPrimary: 'rgb(253,252,250)',
        toolkitCardBgColorSecondary: 'rgb(253,252,250)',
        toolkitCardBgColorTertiary: '#f3f3f3',
        teamChatCardSelectedColor: 'rgb(217,217,217)',
        componentsWrapperBg: '#F5F5F7',
        componentsSecondaryWrapperBg: 'rgb(253,252,250)',
        textareaBorder: 'rgba(0, 0, 0, 0.1)',
        textAreaBgColor: 'rgba(255, 255, 255, 1)',
        dropdownBgColor: 'rgba(255, 255, 255, 1)',
        dataLoaderCardBorder: '#000',
        tableBackgroundColor: 'rgb(253,252,250)',
        sliderBackgroundColor: '#000',
        dropdownSecondaryBgColor: 'rgb(253,252,250)',
        commandMenuBackgroundColor: '#F5F5F7',
        warningToastTextColor: 'rgb(110,110,110)',
        sessionDropdownBorder: '2px solid #cccccc',
        tagColor: 'white',
        imageBrightness: '',
        dialogBorder: 'transparent',
        linkTextColor: '#00AFF4',
        textDisabled: '#00000066',
        markdownColor: prism,
    },
    typography: {
        contentPrimary: 'rgb(50,50,50)',
        contentSecondary: 'rgb(110,110,110)',
        contentTertiary: '#000000CC',
        contentQuaternary: 'rgb(189,189,189)',
    },
    heading: {
        contentPrimary: 'rgb(0,0,0)',
        contentSecondary: 'rgb(49,49,49)',
        contentTertiary: 'rgb(172,172, 173)',
    },
    button: {
        primary: {
            color: '#fff',
            bgColor: '#111',
            hoverBgColor: 'rgba(0, 0, 0, 0.5)',
            pressedBgColor: 'rgba(0, 0, 0, 0.7)',
            pressedBorderColor: 'rgba(0, 0, 0, 0.2)',
        },
        secondary: {
            color: '#000000CC',
            bgColor: '#F5F5F7',
            hoverBgColor: 'rgba(0, 0, 0, 0.2)',
            pressedBgColor: 'rgba(0, 0, 0, 0.7)',
            pressedBorderColor: '#000000',
        },
        tertiary: {
            color: 'rgba(0, 0, 0, 0.7)',
            bgColor: 'transparent',
            hoverBgColor: 'rgba(0, 0, 0, 0.1)',
            pressedBgColor: 'rgba(255, 255, 255, 0.2)',
            pressedBorderColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    contentLoader: {
        bgColor: '#d1d1d1',
        fgColor: '#c0c0c0',
        mainBgColor: '#fff',
        borderColor: '#e0e0e0',
    },
    textFiled: {
        primary: {
            bgColor: '#FFF',
            color: '#000',
            borderColor: 'rgba(0, 0, 0, 0.1)',
            activeBoxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
            activeBorderColor: '#000',
            activeBgColor: 'rgba(255, 255, 255, 0.3)',
            errorBorderColor: '#ef5533',
            errorColor: '#ef5533',
        },
    },
    tabs: {
        color: '#0000004D',
        hoverBgColor: 'rgba(0, 0, 0, 0.2)',
        activeColor: '#000',
        activeBgColor: '#fff',
        borderColor: '#000',
    },

    // new colors
    basicForeground: {
        white: '#FFF',
        white8: '#FFFFFFCC',
        white6: '#FFFFFF99',
        white4: '#FFFFFF66',
        white3: '#FFFFFF4D',
        white2: '#FFFFFF33',
        white1: '#FFFFFF1A',
        black1: '#0000001A',
        black2: '#00000033',
        black3: '#0000004D',
        black5: '#00000080',
        black7: '#000000B2',
        black8: '#000000CC',
        black: '#000000',
    },
    foundation: {
        primaryA: '#FFFFFF',
        primaryB: '#000000',
        accentBlue: '#18A0FB',
        accentYellow: '#FFC700',
        accentGreen: '#1BC47D',
        negative: '#EF5533',
        warning: '#EEA03C',
        positive: '#1BC47D',
        purple: '#BD47FF',
        beige: '#E3D6BD',
    },
    core: {
        background: {
            backgroundPrimary: '#FFFFFF',
            backgroundSecondary: '#000000',
            backgroundTertiary: '#F5F5F7',
            backgroundElementsA: '#0000001A',
            backgroundElementsB: '#FFFFFF33',
            backgroundMain: '#18A0FB',
        },
        content: {
            contentPrimary: '#000000',
            contentSecondary: '#000000CC',
            contentTertiary: '#0000004D',
            contentQuaternary: '#FFFFFF',
        },
        border: {
            borderPrimary: '#00000033',
            borderSecondary: '#FFFFFF33',
            borderTertiary: '#0000004D',
            borderQuaternary: '#d4d4d479',
            borderSelectedA: '#000000',
            borderSelectedB: '#FFFFFF',
            borderSelectedC: '#18A0FB',
        },
    },
    coreExtensions: {
        background: {
            backgroundDisabled: '#0000001A',
            backgroundOverlayDark: '#00000033',
            backgroundOverlayLight: '#FFFFFF33',
            backgroundAccent: '#18A0FB',
            backgroundNegative: '#EF5533',
            backgroundWarning: '#EEA03C',
            backgroundPositive: '#17C568',
        },
        content: {
            contentDisabled: '#00000066',
            contentExtra: '#000000CC',
            contentExtra6: '#00000099',
            contentAccent: '#18A0FB',
            contentNegative: '#F01D1D',
            contentWarning: '#EEA03C',
            contentPositive: '#17C568',
        },
        border: {
            borderDisabled: '#00000066',
            borderHover: '#0000000D',
            borderPressed: '#000000',
            borderNegative: '#EF5533',
            borderWarning: '#EEA03C',
            borderPositive: '#17C568',
        },
        multiplayer: {
            mpGray: '#D9D9D9',
            mpGreen: '#17C568',
            mpPink: '#FA2D5A',
            mpLightBlue: '#68B3FD',
            mpRed: '#EF5533',
            mpBlue: '#1B9DFE',
            mpPurple: '#BD47FF',
        },
        tags: {
            tagsBlack: '#000000',
            tagsWhite: '#FFFFFF',
            tagsGrey: '#D9D9D9E5',
            tagsGreen: '#17C568E5',
            tagsPink: '#FA2D5AE5',
            tagsLightBlue: '#68B3FDE5',
            tagsRed: '#EF5533E5',
            tagsBlue: '#1B9DFEE5',
            tagsPurple: '#BD47FFE5',
            tagsYellow: '#FFC700E5',
            tagsOrange: '#EEA03CE5',
        },
    },
}

export { lightTheme, darkTheme }
